export default {
  "general": {
    "loading_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading in progress"])},
    "refresh_page": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refresh the page"])}
  },
  "error": {
    "generic_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error occurred while loading the experiment. Please refresh the page"])}
  },
  "permissions": {
    "voice_unsupported": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["An error has occurred. Voice recording does not appear to be compatible with your computer"])},
    "voice_permission_denied": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Permission denied for your microphone"])}
  }
}